module.exports = __webpack_public_path__ + "img/punto-di-acquisto.127c8ba7.svg";